const { default: ManageTemplate } = require("./managetemplate")

const TemplateBase=()=>{
    return(<div className="w-full">
    <ManageTemplate/>
    
    </div>)
}
export default TemplateBase